import { useParams, NavLink } from 'react-router-dom';
import { getTranslate } from '../../../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../../../utils/getLocatPath/getLocalPath';
import { isExternalLink } from '../../../../utils/isExternalLink/isExternalLink';
import styles from '../Footer.module.scss';

export const Menu = ({ upFooter, upContact }) => {
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const { menu } = upFooter.acf;
  const { address_text, address_link, phone, email } = upContact.acf;

  return (
    <div className={styles.menu}>
      <div className="container">
        <div className={styles.menu_body}>
          <div className={styles.menu_logo}>
            <NavLink to={l('', lang)} className={styles.menu_logo_content}>
              <div className={styles.menu_logo_content_img}>📖</div>
              <div className={styles.menu_logo_content_text}>
                <span>{t('Орталық балалар кітапханасы', 'Центральная детская библиотека', lang)}</span>
                <span>{t('Оралхан Бөкей атындағы · Өскемен', 'им. Оралхана Бокея · Өскемен', lang)}</span>
              </div>
            </NavLink>
            <div className={styles.menu_logo_text}>{menu.text[lang]}</div>
          </div>
          {menu.menu.map((el, idx) => {
            const { title, links } = el;
            return (
              <div key={idx} className={styles.menu_content}>
                <div className={styles.menu_content_title}>{title[lang]}</div>
                <ul className={styles.menu_content_list}>
                  {links.map((el, idx) => {
                    const { title, link } = el;
                    const isLink = isExternalLink(link);
                    return isLink ? (
                      <li key={idx} className={styles.menu_content_item}>
                        <a href={link} target="_black" className={styles.menu_content_link}>
                          {title[lang]}
                        </a>
                      </li>
                    ) : (
                      <li key={idx} className={styles.menu_content_item}>
                        <NavLink to={link} className={styles.menu_content_link}>
                          {title[lang]}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
          <div className={styles.menu_content}>
            <div className={styles.menu_content_title}>{t('Байланыс', 'Контакты', lang)}</div>
            <ul className={styles.menu_content_list}>
              <li className={styles.menu_content_item}>
                <a href={address_link} target="_black" className={styles.menu_content_link}>
                  {address_text[lang]}
                </a>
              </li>
              {phone.map((el, idx) => {
                const { text, link } = el;
                return (
                  <li key={idx} className={styles.menu_content_item}>
                    <a href={`tel:${link}`} className={styles.menu_content_link}>
                      {text}
                    </a>
                  </li>
                );
              })}
              <li className={styles.menu_content_item}>
                <a href={`mailto:${email}`} className={styles.menu_content_link}>
                  {email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
